interface NameHaver {
  firstName?: string;
  lastName?: string;
}

export default function getFullName({ firstName, lastName }: NameHaver) {
  if (!firstName && !lastName) return null;
  return [firstName, lastName].filter(Boolean).join(' ');
}
